import { CardWithTitle, Spinner } from 'commons/components';
import { STATS_GENERAL_PAGE } from 'config/upsellFlowSources';
import { useTranslationStatistics } from 'domains/Statistics/hooks';
import { STATS_PLAN_1_AND_2 } from 'domains/Statistics/utils';
import SalesChannelsRevenueBarChart from './SalesChannelsRevenueBarChart';
import useGetSalesChannelsRevenue from './useGetSalesChannelsRevenue';
import ChartOrPlaceholder from '../ChartOrPlaceholder';
import GenericError from '../GenericError';

function SalesChannelsRevenueCard() {
  const t = useTranslationStatistics();
  const {
    fetchSalesChannelsRevenue,
    salesChannelsRevenue,
    isLoading,
    isError,
    isSuccess,
    hasComparedFilter,
  } = useGetSalesChannelsRevenue();

  return (
    <CardWithTitle title={t('statistics.salesChannelsRevenueCard.title')}>
      <ChartOrPlaceholder
        type="bars-stacked"
        height={500}
        statsPlanRequired={STATS_PLAN_1_AND_2}
        upsellSource={STATS_GENERAL_PAGE}
      >
        {isLoading && <Spinner size="medium" />}
        {isError && <GenericError onRetry={fetchSalesChannelsRevenue} />}
        {isSuccess && salesChannelsRevenue && (
          <SalesChannelsRevenueBarChart
            granularity={salesChannelsRevenue.granularity}
            hasComparedFilter={hasComparedFilter}
            values={salesChannelsRevenue.results}
          />
        )}
      </ChartOrPlaceholder>
    </CardWithTitle>
  );
}

export default SalesChannelsRevenueCard;
